// extracted by mini-css-extract-plugin
var _1 = "src-components-EditNotePage-_UpperMessageBar__upperMessageBar--HzqNKgfprkjCMuLJzs7d";
export { _1 as "upperMessageBar" }
